import {BlockEmbed} from './block';

class Divider extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  index() {
    return 0;
  }
}
Divider.blotName = 'divider';
Divider.tagName = 'HR';

export default Divider;